/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const UpdateSearchResultDecisionResponseDTODecisionEnum = {
    Saleable: 'SALEABLE',
    Recheck: 'RECHECK',
    Unsaleable: 'UNSALEABLE'
};
/**
 * Check if a given object implements the UpdateSearchResultDecisionResponseDTO interface.
 */
export function instanceOfUpdateSearchResultDecisionResponseDTO(value) {
    return true;
}
export function UpdateSearchResultDecisionResponseDTOFromJSON(json) {
    return UpdateSearchResultDecisionResponseDTOFromJSONTyped(json, false);
}
export function UpdateSearchResultDecisionResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'updatedCount': json['updatedCount'] == null ? undefined : json['updatedCount'],
        'decision': json['decision'] == null ? undefined : json['decision'],
    };
}
export function UpdateSearchResultDecisionResponseDTOToJSON(json) {
    return UpdateSearchResultDecisionResponseDTOToJSONTyped(json, false);
}
export function UpdateSearchResultDecisionResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'updatedCount': value['updatedCount'],
        'decision': value['decision'],
    };
}
